<template>
    <b-modal id="ResetPassword" centered size="lg" ref="resetPasswordModal" no-close-on-esc
        no-close-on-backdrop>
        <template #modal-header class="mx-auto">
            <h5 class="modal-title modal-title-centered">Reset Password</h5>
        </template>
        <template #default>
            <p class="modal-warning-text">
                An email will be sent to the user's email containing verification/reset password link.
                <br />
                Note:The user's password will not be changed until they provide a new password through the reset password
                link.
            </p>
            <p>
                <!--<span class="errorMessage" v-if="v$.form.$error">Reason cannot be blank.</span>-->
            </p>
            <div class="container">
                <div class="mb-3 row">
                    <label for="inputEmail3"
                        class="col-md-2 col-form-label"><!--<span class="requiredinput">*</span>-->Reason:</label>
                    <div class="col-md-10">
                        <textarea class="reset-password-reason" v-model="form.reason" v-sanitize-html="form.reason" />
                    </div>
                </div>
            </div>

        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button class="um-btn" @click="cancelChanges()">Cancel</b-button>
            <b-button class="um-btn" @click="resetUserPassword()">Submit</b-button>
        </template>
    </b-modal>
    <InfoPopup :popupmessage="info.message" ref="InfoModel"></InfoPopup>
    <Teleport to="body">
        <loading v-model:active="isLoading" :can-cancel="true" :z-index="10000"></loading>
    </Teleport>
    <ErrorMessage ref="errorMessageRef" :errorMessage="error" callbackOnClose></ErrorMessage>
</template>
<script>
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import service from "../../services/api.services";
import InfoPopup from "./InfoPopup";
import { Component as Loading } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import { eventbus } from "../../main";
import ErrorMessage from "./ErrorMessage";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    name: "ResetPassword",
    components: {
        InfoPopup,
        Loading,
        ErrorMessage
    },
    data() {
        return {
            form: {
                reason: ""
            },
            info: { message: "" },
            isLoading: false,
            error: ""
        };
    },
    validations: {
        form: {
            reason: { required }
        }
    },
    props: {
        userDetail: {}
    },
    mounted() {
        var that = this;
        eventbus.on("confirmOkChanges", function () {
            that.okChanges();
        });
    },
    methods: {
        clearForm: function () {
            this.form.reason = "";
            //this.v$.form.$reset();
        },
        okChanges: function () {
            if (this.$refs.InfoModel && this.$refs.InfoModel.$refs["InfoPopupModel"])
                this.$refs.InfoModel.$refs["InfoPopupModel"].hide();
            if (typeof this.$refs["resetPasswordModal"] !== "undefined")
                this.$refs["resetPasswordModal"].hide();
            this.clearForm();
        },
        cancelChanges: function () {
            this.$refs["resetPasswordModal"].hide();
            this.clearForm();
        },

        resetUserPassword: function () {

            this.resetPassword()
        },

        async resetPassword() {
            var that = this
            that.isLoading = true;
            await service.ResetUserPassword({ userDetail: this.userDetail, passwordResetReason: (this.form.reason) })
                .then(response => {
                    if (response.data.isPasswordChanged == true) {
                        that.isLoading = false;
                        that.info.message = "Password Reset email is sent successfully";
                        that.$refs.InfoModel.$refs["InfoPopupModel"].show();
                        that.$nextTick(function () {
                            if (that.$refs["resetPasswordModal"]) that.$refs["resetPasswordModal"].hide();
                        });
                    }
                    else {
                        that.error = "error occured while sending Password Reset email."
                        if (that.$refs.errorMessageRef && that.$refs.errorMessageRef.$refs["ErrorMessageModel"])
                            that.$refs.errorMessageRef.$refs["ErrorMessageModel"].show();
                        else
                            that.$bvModal.show("errormessage");
                        that.isLoading = false;
                    }
                    that.form.reason = "";
                })
                .catch(error => {
                    that.isLoading = false;
                    console.log("api error:" + error);
                });

        },
    }
}
</script>
<style>
.reset-password-reason {
    width: 312px !important;
    resize: none;
}

.requiredinput {
    color: red;
}

.hasError label {
    color: red !important;
}

.hasError input {
    border-color: red !important;
}

.noError input {
    border-color: white !important;
}

.modal-backdrop {
    opacity: 0.5;
    transition: opacity 0.2s;
    border-color: red;
}

.modal-title {
    margin: auto;
}

.errorMessage {
    color: red;
    font-size: 0.8em;
    font-weight: 500;
}
</style>
